export default function SystemGaugeChart({ current, total, size = 160, title }) {

    // PROPERTIES
    const strokeWidth = 16;
    const radius = (size - strokeWidth) / 2;
    const circumference = Math.PI * radius;
    const progress = Math.min(current / total, 1);
    const offset = circumference - progress * circumference;
    const percent = Math.round(progress * 100);

    // BUILD
    return (
        <div className="flex flex-col items-center space-y-[8px]">
            <svg width={size}
                 height={size / 2}
                 viewBox={`0 0 ${size} ${size / 2}`} >

                {/* Background arc */}
                <path d={`M ${strokeWidth / 2} ${size / 2} A ${radius} ${radius} 0 0 1 ${size - strokeWidth / 2} ${size / 2}`}
                      fill="none"
                      stroke="#e5e7eb"
                      strokeWidth={strokeWidth} />

                {/* Progress arc */}
                <path
                    d={`M ${strokeWidth / 2} ${size / 2} A ${radius} ${radius} 0 0 1 ${size - strokeWidth / 2} ${size / 2}`}
                    fill="none"
                    stroke="#4AB8F8"
                    strokeWidth={strokeWidth}
                    strokeDasharray={circumference}
                    strokeDashoffset={offset}
                    style={{ transition: "stroke-dashoffset 0.6s ease" }} />

                <text x="50%"
                      y="70%"
                      textAnchor="middle"
                      fontSize={size * 0.15}
                      fontWeight="600"
                      fill="#4AB8F8">
                    {percent}%
                </text>

                {/* Texte secondaire (valeur absolue) */}
                <text x="50%"
                      y="95%"
                      textAnchor="middle"
                      fontSize={size * 0.09}
                      fill="#8291A9">
                    {current} / {total}
                </text>
            </svg>

            {/* Gauge title */}
            <p className="text-sm text-greyLight11 font-medium">
                {title}
            </p>
        </div>
    );
}
